// extracted by mini-css-extract-plugin
module.exports = {"error":"_error_error__hHbvv","error__heading":"_error_error__heading__CuYbo","error__copy":"_error_error__copy__AazTO"};